// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291335/js/" + chunkId + "." + {"44":"64908e58","225":"cfd43d3c","481":"123a5943","486":"f63ae52f","770":"2d81e057"}[chunkId] + ".0.5965779345744369.chunk.js";
};